import React, { useEffect, useState } from "react";
import { FloppyDisk } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function AdminSEO() {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(null);

  const load = () => api.get("/admin/seo").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const save = async (item) => {
    setSaving(item.page);
    try {
      await api.put("/admin/seo", item);
      toast.success(`${item.page} SEO saved`);
    } catch {
      toast.error("Save failed");
    } finally {
      setSaving(null);
    }
  };

  const update = (idx, key, val) => {
    setItems(items.map((it, i) => i === idx ? { ...it, [key]: val } : it));
  };

  return (
    <div data-testid="admin-seo">
      <div className="mb-6">
        <h1 className="h2 text-[#0A1F15]">SEO Settings</h1>
        <p className="text-[#5C7368]">Edit meta tags per page for search engine optimization.</p>
      </div>

      <div className="space-y-3">
        {items.map((it, idx) => (
          <details key={it.page} className="bg-white rounded-2xl border border-[#E5E3DB] overflow-hidden">
            <summary className="p-4 cursor-pointer hover:bg-[#F9F8F6] flex items-center justify-between">
              <div>
                <span className="font-bold capitalize text-[#0A1F15]">{it.page}</span>
                <span className="ml-2 text-sm text-[#5C7368] truncate">{it.title}</span>
              </div>
              <span className="text-xs text-[#5C7368]">▼</span>
            </summary>
            <div className="p-5 border-t border-[#E5E3DB] space-y-3">
              <F label="Title (50-60 chars)">
                <input value={it.title} onChange={e => update(idx, "title", e.target.value)} className="inp"/>
                <p className="text-xs text-[#5C7368] mt-1">{it.title?.length || 0} characters</p>
              </F>
              <F label="Description (150-160 chars)">
                <textarea rows={2} value={it.description} onChange={e => update(idx, "description", e.target.value)} className="inp resize-none"/>
                <p className="text-xs text-[#5C7368] mt-1">{it.description?.length || 0} characters</p>
              </F>
              <F label="Keywords (comma separated)">
                <input value={it.keywords} onChange={e => update(idx, "keywords", e.target.value)} className="inp"/>
              </F>
              <button type="button" onClick={() => save(it)} disabled={saving === it.page} className="btn-primary !py-2.5 text-sm disabled:opacity-60">
                <FloppyDisk weight="bold" size={16}/> {saving === it.page ? "Saving..." : "Save"}
              </button>
            </div>
          </details>
        ))}
      </div>
      <style>{`.inp{width:100%;padding:0.75rem 1rem;border-radius:0.75rem;border:1px solid #E5E3DB;background:white;}`}</style>
    </div>
  );
}

function F({ label, children }) {
  return (
    <div>
      <label className="block text-xs font-bold uppercase tracking-wider text-[#5C7368] mb-1.5">{label}</label>
      {children}
    </div>
  );
}
